// internationalization
import { useTranslation } from 'react-i18next';

// tanstack
import { createFileRoute, useParams } from '@tanstack/react-router';

// material ui
import { Stack } from '@mui/material';

// api
import { useGetExternalSensorByIdQuery } from '@/api/recalc/endpoints/externalSensorsApiSlice';

// shared components
import PageContainer from '@/components/layout/PageContainer';
import PageHeader from '@/components/layout/PageHeader';
import LinearLoadingIndicator from '@/components/ui/progress/LinearLoadingIndicator';

// feature-components
import ExternalSensorForm from '@/features/devices/components/DevicesForm';

import { skipToken } from '@reduxjs/toolkit/query';

export const Route = createFileRoute(
  '/$accountId/_admin/devices/$deviceId/edit',
)({
  component: RouteComponent,
});

function RouteComponent() {
  const { t } = useTranslation('units-gateways-sensors');
  const { externalSensorId } = useParams({ strict: false });

  const parsedExternalSensorId = externalSensorId
    ? Number(externalSensorId)
    : undefined;
  const queryExternalSensorId =
    typeof parsedExternalSensorId === 'number' &&
    Number.isFinite(parsedExternalSensorId)
      ? parsedExternalSensorId
      : skipToken;

  const { data: externalSensor, isLoading } = useGetExternalSensorByIdQuery(
    queryExternalSensorId,
  );

  return (
    <>
      <LinearLoadingIndicator isLoading={isLoading} />
      <PageContainer maxWidth="xl" sx={{ py: 2 }}>
        <Stack spacing={2}>
          <PageHeader title={t('externalSensors.editTitle')} />
          {externalSensor && (
            <ExternalSensorForm
              key={externalSensor.ExternalSensorId}
              mode="edit"
              externalSensor={externalSensor}
            />
          )}
        </Stack>
      </PageContainer>
    </>
  );
}
